import PropTypes from 'prop-types';
import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

const MiniCartContext = createContext(null);

export const MiniCartContextProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [product, setProduct] = useState(null);
  const [cartButtonRef, setCartButtonRef] = useState(null);
  const [isMouseInMiniCart, setIsMouseInMiniCart] = useState(false);
  const [isMouseInCartButton, setIsMouseInCartButton] = useState(false);

  const addProduct = (newProduct) => {
    setProduct(newProduct[0]);
  };

  const timeoutId = useRef(null);

  const startHideTimeout = () => {
    timeoutId.current = setTimeout(() => {
      if (!isMouseInMiniCart && !isMouseInCartButton) {
        setIsVisible(false);
      }
    }, 1500);
  };

  const resetTimeout = () => {
    clearTimeout(timeoutId.current);

    startHideTimeout();
  };

  useEffect(
    () =>
      // Nettoyage du timeout lors du démontage
      () => {
        clearTimeout(timeoutId.current);
      },
    [],
  );

  return (
    <MiniCartContext.Provider
      value={{
        isVisible,
        product,
        addProduct,
        setIsVisible,
        cartButtonRef,
        setCartButtonRef,
        resetTimeout,
        startHideTimeout,
        setIsMouseInMiniCart,
        setIsMouseInCartButton,
        timeoutId,
      }}
    >
      {children}
    </MiniCartContext.Provider>
  );
};

export const useMiniCartContext = () => useContext(MiniCartContext);

MiniCartContextProvider.defaultProps = {};

MiniCartContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
